import { render, staticRenderFns } from "./TransformLog.vue?vue&type=template&id=ca986320&scoped=true"
import script from "./TransformLog.vue?vue&type=script&lang=js"
export * from "./TransformLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca986320",
  null
  
)

export default component.exports